import { i18n } from "@/resources/locales";

export const GREEN = {
  type: "GREEN",
  color: "#04df31",
};
export const YELLOW = {
  type: "YELLOW",
  color: "#f8d800",
};
export const RED = {
  type: "RED",
  color: "#ff0000",
};

export enum REASON {
  TYPE_REASON_EATING = "REASON_EATING_TYPE",
  TYPE_REASON_RESTING = "REASON_RESTING_TYPE",
  TYPE_REASON_FOCUSED = "REASON_FOCUSED_TYPE",
  TYPE_REASON_CALL = "REASON_CALL_TYPE",
  TYPE_REASON_VACATION = "REASON_VACATION_TYPE",
}

const TYPE_REASON_EATING = "REASON_EATING_TYPE",
  TYPE_REASON_RESTING = "REASON_RESTING_TYPE",
  TYPE_REASON_FOCUSED = "REASON_FOCUSED_TYPE",
  TYPE_REASON_CALL = "REASON_CALL_TYPE",
  TYPE_REASON_VACATION = "REASON_VACATION_TYPE",
  ONLINE = "ONLINE",
  OFFLINE = "OFFLINE";

export const REASONS = [
  {
    emoji: "",
    label: i18n.t("status.available"),
    id: 1,
    code: "",
    type: ONLINE,
  },
  {
    emoji: "",
    label: i18n.t("status.busy"),
    id: 2,
    code: "U+1F44B",
    type: OFFLINE,
  },
  {
    emoji: "🥗",
    label: i18n.t("status.reasons.eating"),
    id: 3,
    code: "U+1F957",
    type: TYPE_REASON_EATING,
  },
  {
    emoji: "😴",
    label: i18n.t("status.reasons.resting"),
    id: 4,
    code: "U+1F634",
    type: TYPE_REASON_RESTING,
  },
  {
    emoji: "💪",
    label: i18n.t("status.reasons.focused"),
    id: 5,
    code: "U+1F4AA",
    type: TYPE_REASON_FOCUSED,
  },
  {
    emoji: "📞",
    label: i18n.t("status.reasons.call"),
    id: 6,
    code: "U+1F4DE",
    type: TYPE_REASON_CALL,
  },
  {
    emoji: "⛱",
    label: i18n.t("status.reasons.vacation"),
    id: 7,
    code: "U+26F1",
    type: TYPE_REASON_VACATION,
  },
  {
    emoji: null,
    label: i18n.t("status.reasons.anotherReason"),
    id: 8,
    code: "",
    type: null,
  },
];
